import axios from '@/libs/api.request'

export const chargeGet = (data) => {
  return axios.request({
    url: '/print/charge',
    params: data,
    method: 'get'
  })
}
export const chargePut = data => {
  return axios.request({
    url: '/print/charge',
    data,
    method: 'put'
  })
}
export const chargeInfo = data => {
  return axios.request({
    url: '/print/charge/info',
    params: data,
    method: 'get'
  })
}
export const DelCharge = data => {
  return axios.request({
    url: '/print/charge/del',
    data,
    method: 'put'
  })
}
